module.exports = __webpack_public_path__ + "img/sv101.3cebe339.svg";